module.exports = __webpack_public_path__ + "img/shiba-body-level4.552198b7.png";